import * as actions from './backbroundTypes';

export const socketconnection = (socket) =>{
    return {
        type: actions.WEBSOCKETCONNECTION,
        payload: socket
    }
}

export const networkstatus = data => {
    return {
        type: actions.NETWORK,
        payload: data
    }
}

export const websocketstatus = data => {
    return {
        type: actions.WEBSOCKETSTATUS,
        payload: data
    }
}
